import type { DialogsContainerProps } from '@confluence/dialogs/entry-points/DialogsStateContainer.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { OverrideMovePageParams } from '../useMovePageHandler.ts';

export const MovePageDialog: LoadableType<
	{
		contentId: string;
		spaceKey: string;
		isUnpublishedDraft?: boolean;
		referrer?: string;
		isMovingDraftVersion?: boolean;
		onUpdateSuccess?: () => void;
		submitOverride?: (args: OverrideMovePageParams) => void;
		onContinue?: () => void;
		requireParent?: boolean;
	} & DialogsContainerProps
> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-MovePageDialog" */ './MovePageDialog.tsx'))
			.MovePageDialog,
});
